import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { H2, P, ShareIcon } from '@futurefamily/ef-components';
import Calculator from '../Calculator';
import * as config from 'config';

const Wrapper = styled.div`
  padding-top: var(--page-top-offset);
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Heading = styled(H2)`
  color: var(--teal);
  font-weight: bold;
`

function PaymentOptions () {
  const isDesktop = useMediaQuery({
    query: '(min-width: 768px)'
  });

  return (
    <Wrapper>
      <div className="container">
        <Heading>PAYMENT OPTIONS {isDesktop && <ShareIcon basename={config.BASENAME} className="float-end" />}</Heading>
        <P>
          Select the best option for you by understanding your payment options.
          If you have insurance and/or an employer benefits plan, this could help reduce your treatment costs.
        </P>
      </div>

      <Calculator className="flex-grow-1" />
    </Wrapper>
  );
};

export default PaymentOptions;
